import React from 'react';
import 'react-loading-skeleton/dist/skeleton.css';
import '../../styles/bitacora.css';
import '../../styles/sales.css';
import '../../styles/saleStatusBadges.css';
import SaleDetailModal from '../../components/Sales/SaleDetailModal';
import { TableCard } from '../../components/ui';
import { useSalesList } from './useSalesList';
import SalesListFiltersCard from './SalesListFiltersCard';
import SalesListTable from './SalesListTable';

/**
 * Sales list for POS admins (Administrador POS / ROLE_POS_ADMIN).
 * All branches of the commerce; columns differ from the seller view on purpose.
 */
const PosAdminSalesPage = () => {
  const {
    sales,
    loading,
    selectedSale,
    showDetailModal,
    setShowDetailModal,
    setSelectedSale,
    exporting,
    pagination,
    filters,
    branchOptions,
    approvalStatusOptions,
    settlementStatusOptions,
    handleFilterChange,
    handleApplyFilters,
    handleClearFilters,
    handleViewDetail,
    handleGoToCustomer,
    handleExportExcel,
    Pagination,
  } = useSalesList({ includeBranchFilter: true });

  const selectedBranchLabel = branchOptions.find(
    (branch) => String(branch.id) === String(filters.branch_id)
  )?.name;

  return (
    <div className="page-content sales-page sales-page--pos-admin">
      <div className="page-title mb-2">
        <div className="row">
          <div className="col-12 col-md-6 order-md-1 order-last">
            <h3 style={{ marginBottom: 'var(--rg-space-2xs)' }}>Ventas del comercio</h3>
            <p
              className="text-subtitle text-muted mb-0"
              style={{
                marginLeft: 'var(--rg-space-md)',
                marginTop: '0',
                marginBottom: '0',
                lineHeight: 1.35,
              }}
            >
              {filters.branch_id
                ? `Sucursal: ${selectedBranchLabel || filters.branch_id}`
                : 'Todas las sucursales'}
            </p>
          </div>
        </div>
      </div>

      <section className="section">
        <TableCard
          toolbar={(
            <SalesListFiltersCard
              filters={filters}
              approvalStatusOptions={approvalStatusOptions}
              settlementStatusOptions={settlementStatusOptions}
              branchOptions={branchOptions}
              includeBranchFilter
              loading={loading}
              exporting={exporting}
              onFilterChange={handleFilterChange}
              onApplyFilters={handleApplyFilters}
              onClearFilters={handleClearFilters}
              onExportExcel={handleExportExcel}
            />
          )}
          table={(
            <SalesListTable
              sales={sales}
              loading={loading}
              pagination={pagination}
              showBranchColumn
              onViewDetail={handleViewDetail}
              onGoToCustomer={handleGoToCustomer}
            />
          )}
          pagination={<Pagination loading={loading} />}
        />

        {showDetailModal && (
          <SaleDetailModal
            saleId={selectedSale.id}
            customerId={selectedSale.customer.id}
            onClose={() => {
              setShowDetailModal(false);
              setSelectedSale(null);
            }}
          />
        )}
      </section>
    </div>
  );
};

export default PosAdminSalesPage;
